import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoHeaderModule } from '../logo-header/logo-header.module';
import { LoginHeaderComponent } from './login-header.component';

@NgModule({
  declarations: [LoginHeaderComponent],
  imports: [CommonModule, LogoHeaderModule],
  exports: [LoginHeaderComponent]
})
export class LoginHeaderModule {}
